function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from "vuex";
import tasks from '@/js/tasks';
import { ROLES_LIST } from '@/js/constants';
import DialogsComponent from "@/components/DialogsComponent.vue";
import dataplex_service from '@/apps/data-platform/services/data_quality/dataplex_service';
export default {
  components: {
    DialogsComponent: DialogsComponent
  },
  data: function data() {
    return {
      tab: 0,
      filters: {},
      filter_enabled: false,
      //true,
      dimension: {},
      dimension_selected: {},
      expectation_selected: {},
      expectation: {},
      collapse_filter: false,
      dimensions: [],
      dimensions_to_filter: [],
      expectations: [],
      expectations_to_filter: [],
      pagination_dimensions: {
        total: 0,
        limit: 10,
        offset: 1,
        current: 1
      },
      pagination_expectations: {
        total: 0,
        limit: 10,
        offset: 1,
        current: 1
      },
      headers_dimensions: [{
        value: 'value',
        text: 'Valor'
      }, {
        value: 'text',
        text: 'Nombre'
      }, {
        value: 'description',
        text: 'Descripción'
      }, {
        value: 'actions',
        text: 'Acciones'
      }],
      headers_expectations: [{
        value: 'value',
        text: 'Valor'
      }, {
        value: 'text',
        text: 'Nombre'
      }, {
        value: 'description',
        text: 'Descripción'
      }, {
        value: 'example',
        text: 'Ejemplos'
      }, {
        value: 'actions',
        text: 'Acciones'
      }],
      type_values: [{
        value: 'undefined',
        text: 'Ninguno'
      }, {
        value: 'text',
        text: 'Texto'
      }, {
        value: 'range',
        text: 'Rango de Valores'
      }, {
        value: 'range_statistic',
        text: 'Rango de Valores Estadísticos'
      }, {
        value: 'set',
        text: 'Conjunto de Valores'
      }],
      edit: false
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('data-platform', ['projects', 'catalogs', 'orgs', 'isDomainItc', 'has_dataplex_active', 'has_dataplex_active'])), {}, {
    getClassTable: function getClassTable() {
      if (this.filter_enabled) {
        return 'col-md-9 col-sm-12';
      } else {
        return 'col-sm-12';
      }
    }
  }),
  created: function created() {
    if (!this.has_dataplex_active) {
      this.$router.push({
        name: 'HomePage'
      });
      return;
    }
    this.onListDimensions();
    this.onListExpectations();
  },
  methods: {
    traductor: function traductor(key) {
      return this.$i18n.t(key);
    },
    onEnableFilter: function onEnableFilter() {
      this.filter_enabled = !this.filter_enabled;
    },
    onListDimensions: function onListDimensions() {
      var _this = this;
      dataplex_service.getDimensions({}).then(function (response) {
        _this.dimensions = response.data;
        _this.dimensions_to_filter = Object.assign([], _this.dimensions);
        _this.pagination_dimensions.total = _this.dimensions.length;
        _this.$store.commit('data-platform/setDataplexDimensions', _this.dimensions);
      });
    },
    onListExpectations: function onListExpectations() {
      var _this2 = this;
      dataplex_service.getExpectations({}).then(function (response) {
        _this2.expectations = response.data;
        _this2.expectations_to_filter = Object.assign([], _this2.expectations);
        _this2.pagination_expectations.total = _this2.expectations.length;
        _this2.$store.commit('data-platform/setDataplexExpectations', _this2.expectations);
      });
    },
    onSearch: function onSearch() {
      var _this3 = this;
      if (this.tab == 0) {
        this.dimensions = Object.assign([], this.dimensions_to_filter);
        if (this.filters.value) {
          this.dimensions = this.dimensions.filter(function (x) {
            return x.value.toUpperCase().indexOf(_this3.filters.value.toUpperCase()) != -1;
          });
        }
        if (this.filters.text) {
          this.dimensions = this.dimensions.filter(function (x) {
            return x.text.toUpperCase().indexOf(_this3.filters.text.toUpperCase()) != -1;
          });
        }
      }
      if (this.tab == 1) {
        this.expectations = Object.assign([], this.expectations_to_filter);
        if (this.filters.value) {
          this.expectations = this.expectations.filter(function (x) {
            return x.value.toUpperCase().indexOf(_this3.filters.value.toUpperCase()) != -1;
          });
        }
        if (this.filters.text) {
          this.expectations = this.expectations.filter(function (x) {
            return x.text.toUpperCase().indexOf(_this3.filters.text.toUpperCase()) != -1;
          });
        }
      }
    },
    onLimpiar: function onLimpiar() {
      this.dimensions = Object.assign([], this.dimensions_to_filter);
      this.resetFilters();
    },
    resetFilters: function resetFilters() {
      this.filters = {};
      this.onListDimensions();
      this.onListExpectations();
    },
    openDialog: function openDialog() {
      this.dimension = {};
      this.expectation = {};
      this.edit = false;
      if (this.tab == 0) {
        this.$refs["DIALOG_DIMENSION"].onOpen();
      } else if (this.tab == 1) {
        this.$refs["DIALOG_EXPECTATION"].onOpen();
      }
    },
    createDimension: function createDimension() {
      var _this4 = this;
      dataplex_service.createDimension(this.dimension).then(function (response) {
        if (response.success) {
          tasks.toast.success("El registro se guardó correctamente.");
          _this4.$refs["DIALOG_DIMENSION"].onClose();
          _this4.onLimpiar();
        } else {
          tasks.toast.error("No se pudo guardar el registro.");
        }
      });
    },
    updateDimension: function updateDimension() {
      var _this5 = this;
      dataplex_service.updateDimension(this.dimension).then(function (response) {
        if (response.success) {
          tasks.toast.success("El registro se guardó correctamente.");
          _this5.$refs["DIALOG_DIMENSION"].onClose();
          _this5.onLimpiar();
        } else {
          tasks.toast.error("No se pudo guardar el registro.");
        }
      });
    },
    onEditDimension: function onEditDimension(item) {
      this.edit = true;
      this.dimension = Object.assign({}, item);
      this.$refs["DIALOG_DIMENSION"].onOpen();
    },
    onRemoveDimension: function onRemoveDimension(item) {
      this.dimension_selected = item;
      this.$refs["DIALOG_REMOVE_DIMENSION"].onOpen();
    },
    onConfirmRemoveDimension: function onConfirmRemoveDimension(value) {
      var _this6 = this;
      if (value) {
        dataplex_service.removeDimension(this.dimension_selected).then(function (response) {
          if (response.success) {
            tasks.toast.success("El registro se eliminó correctamente.");
            _this6.$refs["DIALOG_REMOVE_DIMENSION"].onClose();
            _this6.onLimpiar();
          } else {
            tasks.toast.error("No se pudo eliminar el registro.");
          }
        });
      } else {
        this.$refs["DIALOG_REMOVE_DIMENSION"].onClose();
      }
    },
    createExpectation: function createExpectation() {
      var _this7 = this;
      dataplex_service.createExpectation(this.expectation).then(function (response) {
        if (response.success) {
          tasks.toast.success("El registro se guardó correctamente.");
          _this7.$refs["DIALOG_EXPECTATION"].onClose();
          _this7.onLimpiar();
        } else {
          tasks.toast.error("No se pudo guardar el registro.");
        }
      });
    },
    updateExpectation: function updateExpectation() {
      var _this8 = this;
      dataplex_service.updateExpectation(this.expectation).then(function (response) {
        if (response.success) {
          tasks.toast.success("El registro se guardó correctamente.");
          _this8.$refs["DIALOG_EXPECTATION"].onClose();
          _this8.onLimpiar();
        } else {
          tasks.toast.error("No se pudo guardar el registro.");
        }
      });
    },
    onEditExpectation: function onEditExpectation(item) {
      this.edit = true;
      this.expectation = Object.assign({}, item);
      this.$refs["DIALOG_EXPECTATION"].onOpen();
    },
    onRemoveExpectation: function onRemoveExpectation(item) {
      this.expectation_selected = item;
      this.$refs["DIALOG_REMOVE_EXPECTATION"].onOpen();
    },
    onConfirmRemoveExpectation: function onConfirmRemoveExpectation(value) {
      var _this9 = this;
      if (value) {
        dataplex_service.removeExpectation(this.expectation_selected).then(function (response) {
          if (response.success) {
            tasks.toast.success("El registro se eliminó correctamente.");
            _this9.$refs["DIALOG_REMOVE_EXPECTATION"].onClose();
            _this9.onLimpiar();
          } else {
            tasks.toast.error("No se pudo eliminar el registro.");
          }
        });
      } else {
        this.$refs["DIALOG_REMOVE_EXPECTATION"].onClose();
      }
    }
  }
};